import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  handleFormPost,
  handleFormSave,
} from "../commonHandlerFunction/JRFHandlerFunctions";
import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useNavigate, useParams } from "react-router-dom";
import { decryptDataForURL } from "../../../utills/useCryptoUtils";
import VerifyOTPModal from "../commonModalForms/VerifyOTPModal";
import { getUserDetails } from "../../../services/commonFunction";
import { handleSendVerifictionCodeForApprovel } from "../commonHandlerFunction/intenralCertificateHandlerFunction";

const CommercialCertificateButtons = ({
  useFor,
  status,
  ApproveCertificate,
  handlePublish,
  sendForApproval,
  IsPreviewUpload,
  setIsPreviewUpload,
  dailyReportInDocument,
  CCID,
  setIsRejectPopupOpen,
  setIsOverlayLoader
}) => {
  const { t } = useTranslation();
  const [isCustomPopup, setIsCustomPopup] = useState(false);
  const translate = t;
  let navigate = useNavigate();
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split("?")[1]);
  const certificateNo = decryptDataForURL(params.get("certificateNo"));
  const checkIsEnabled2FA = () => {
      if (getUserDetails()?.logged_in_user_info?.usr_certificate_approval_2fa) {
        handleSendVerifictionCodeForApprovel("generate", certificateNo, "", setIsOverlayLoader, setIsCustomPopup)
      }
      else {
        ApproveCertificate()
      }
    }
  return (
    <div className="submit_btns">
      <VerifyOTPModal isCustomPopup={isCustomPopup} setIsCustomPopup={setIsCustomPopup} handleConfirm={ApproveCertificate} certiId={certificateNo} setIsOverlayLoader={setIsOverlayLoader}/>
      <button
        className="cancelBtn"
        type="button"
        // onClick={() => navigate("/operation/commercial-certificate-list")}
        onClick={() => navigate(-1)}
      >
        Back
      </button>
      {/* {
        useFor === "savedCertificate" && (<button
          className="submitBtn"
          type="button"
          onClick={() => ApproveCertificate("posted", 1)}
        >
          Generate
        </button>)
      } */}
      {(status === "approve" || status === "NonLMSApprove") && (
        <>
          <button
            className="submitBtn"
            type="button"
            onClick={() => checkIsEnabled2FA()}
          >
            Approve
          </button>
          <button
            className="submitBtn"
            type="button"
            onClick={(e) => setIsRejectPopupOpen(true)}
          >
            Reject
          </button>
        </>
      )}

      {(status === "publish" || status === "NonLMSPublish") && (
        <button
          className="submitBtn"
          type="button"
          onClick={() => handlePublish()}
        >
          Publish
        </button>
      )}

      {(status === "posted" || status === "NonLMSPosted") && (
        <button
          className="submitBtn"
          type="button"
          onClick={() => sendForApproval()}
        >
          Send for Approval
        </button>
      )}

      {
        useFor === "daily_report" && (
          <button
            className="submitBtn"
            type="button"
            onClick={() => {
              if (!IsPreviewUpload) {
                setIsPreviewUpload(true);
              }
              else {
                dailyReportInDocument();
              }
            }
            }
          >
            Share Daily Report
          </button>
        )}
    </div>
  );
};


CommercialCertificateButtons.propTypes = {
  setIsPopupOpen: PropTypes.func,
  setJRFCreationType: PropTypes.func,
  handleSubmit: PropTypes.func,
  handleBackButtonFunction: PropTypes.func,
  viewOnly: PropTypes.bool,
};

export default CommercialCertificateButtons;
